export default __webpack_public_path__ + "static/img_0-316678e494dd095838bb770d483738bf.png";